import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import WrongPathErrorView from "presentational/error/WrongPathErrorView";
import { isValidInput } from "lib/textFilter";
import config from "lib/fr-config";
import { getFullUrl, getEssentialUrl } from "lib/urlQueryParser";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;

RootShortcutPortfolioUsername.propTypes = {
  username: PropTypes.string.isRequired
};

function RootShortcutPortfolioUsername(props) {
  const { username, hasLoggedIn } = props;
  const [validType, setValidType] = useState("pending"); // "pending", "invalid"

  const history = useHistory();

  useEffect(() => {
    isValidShortcutText();
  }, []);

  const isValidShortcutText = async () => {
    const isValid = isValidInput("username", username);
    if (!isValid) {
      setValidType("invalid");
      return null;
    }

    if (!username) {
      setValidType("invalid");
      return null;
    } else {
      history.replace(getNextUrl(username));
    }
  };

  const getNextUrl = username => {
    const { refUsername } = REFERRAL_QUERY_INDEX;

    const nextUrl = getFullUrl({
      url: getEssentialUrl({ type: "portfolio" })(username),
      queryObj: { [refUsername]: hasLoggedIn ? undefined : username }
    });
    return nextUrl;
  };

  return (
    <React.Fragment>
      {validType === "invalid" && <WrongPathErrorView />}
    </React.Fragment>
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(RootShortcutPortfolioUsername);
